var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../layout.njk"] = require( "../layout.njk" );
dependencies["../components/terms-conditions.njk"] = require( "../components/terms-conditions.njk" );




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/pages/verify-email.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../layout.njk", true, "src/views/pages/verify-email.njk", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_title"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("robots"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("body_class"))(env, context, frame, runtime, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
output += t_8;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
output += t_10;
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_title(env, context, frame, runtime, cb) {
var lineno = 2;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "Email Address Successfully Verified | List My Practice";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_robots(env, context, frame, runtime, cb) {
var lineno = 3;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "<meta name=\"robots\" content=\"noindex, nofollow\">";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_body_class(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "email-verification";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 7;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n  <main id=\"main-content\" class=\"\">\r\n    <section>\r\n      <div class=\"container mb-30 email-failed hidden\">\r\n        <h1 class=\"mt-0 mb-30 primary-color\">Verification error</h1>\r\n        <p class=\"pb-10\">This verification link has expired. Please enter your credentials on the validation page again. </p>\r\n        <a href=\"/register-to-be-listed\" class=\"btn btn-primary\">\r\n          <span class=\"btn-content\">Go to Validation Page</span></a>\r\n      </div>\r\n      <div class=\"container mb-30 email-verified hidden\">\r\n        <h1 class=\"mt-0 mb-30 primary-color\">Email address successfully verified</h1>\r\n        <p class=\"pb-10\">Your email address has been verified. Click the button below to view and update your listings.</p>\r\n\r\n        <h2 class=\"terms-heading\">Terms and Conditions</h2>\r\n        <div class=\"terms-of-use-scrollable\">\r\n            ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../components/terms-conditions.njk", false, "src/views/pages/verify-email.njk", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
callback(null,t_12);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_15,t_14) {
if(t_15) { cb(t_15); return; }
callback(null,t_14);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n        </div>\r\n        <form action=\"\" class=\"verify-email-form\" id=\"verify-email-form\" name=\"Verify Email\" method=\"post\">\r\n          <div class=\"container mt-40 mb-40\">\r\n              <div class=\"row\">\r\n                  <input id=\"agreement-chk\" type=\"checkbox\" name=\"agreement-chk\" value=\"true\" aria-required=\"true\" >\r\n                  <label id=\"agreement-chk-label\" for=\"agreement-chk\">\r\n                      <svg class=\"svg--icon-checkmark\">\r\n                          <use xlink:href=\"#icon-checkmark\"></use>\r\n                      </svg>\r\n                      <p>\r\n                          <strong>I have read and agree to the Terms and Conditions. I opt to participate in the Indivior Find a SUBLOCADE Treatment Provider Tool per the guidelines in the Terms and Conditions, and have provided my contact information above. I understand that participation in the Indivior Find a SUBLOCADE Treatment Provider Tool is not an endorsement or recommendation of a Healthcare Provider by Indivior, and I agree not to make any such claims or representations. I agree that Indivior Inc. is not responsible for my treatment outcomes.</strong>\r\n                      </p>\r\n                      <p class=\"form-error error-required hidden flex-vertical-center\">Please click the box and type your name below to confirm that you have read and agreed to the Terms and Conditions.</p>\r\n                  </label>\r\n              </div>\r\n              <div class=\"row signature mt-10\">\r\n                  <div class=\"two-thirds column\">\r\n                      <label id=\"signature-label\" for=\"signature\">PLEASE TYPE YOUR NAME TO PROVIDE YOUR CONSENT.\r\n                          <p class=\"form-error error-required hidden flex-vertical-center\">Please type your name in the box below. </p>\r\n                      </label>\r\n                      <input class=\"\" id=\"signature\" name=\"signature\" placeholder=\"\" type=\"text\" value=\"\" aria-required=\"true\">\r\n                  </div>\r\n              </div>\r\n              <div class=\"row mt-40\">\r\n                  <div class=\"one-half column\">\r\n                      <button type=\"submit\" class=\"btn btn-min-width btn-primary\" id=\"verify-email-submit\">\r\n                          <span class=\"btn-content\">View Your Listings</span>\r\n                      </button>\r\n                      <svg class=\"svg--icon-loading hidden\" id=\"verify-email-submit-loading\">\r\n                          <use xlink:href=\"#icon-loading\"></use>\r\n                      </svg>\r\n                  </div>\r\n              </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n      <svg class=\"container mb-30 svg--page-loading hidden\" id=\"verify-email-pending\">\r\n        <use xlink:href=\"#icon-loading\"></use>\r\n      </svg>\r\n    </section>\r\n  </main>\r\n";
cb(null, output);
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_meta_title: b_meta_title,
b_robots: b_robots,
b_body_class: b_body_class,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/pages/verify-email.njk"] , dependencies)